import gql from 'graphql-tag';

export default gql`
  query s3SignedUrl($bucket: String!, $key: String!) {
    s3SignedUrl(bucket: $bucket, key: $key) {
      url
      expiresIn
    }
  }
`;
